import { defineFakeRoute } from 'vite-plugin-fake-server/client'

/**
 * 模拟上传接口，返回文件访问地址
 */
export default defineFakeRoute([
  {
    url: '/mock/upload',
    method: 'post',
    response: () => {
      return {
        error: '',
        status: 1,
        data: {
          url: 'https://yun-campus-res.oss-cn-shenzhen.aliyuncs.com/public/images/logo.svg',
        },
      }
    },
  },
])
